import { MpsButtonTemplate } from '@mps/mps-kit/mps-button';

export const hpc_button_templates: Record<string, MpsButtonTemplate> = {
  //example pour montrer la personnalisation d'un template existant
  //[MpsAction.ADD_ENTITY]:       { action:MpsAction.ADD_ENTITY,  icon: 'add_circle',    label: 'entities.%entity%.actions.add-hpc' },

  //@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  //.        table buttons templates
  //@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  btn_table_top_left: {
    type: 'button.secondary',
    size: 'medium',
  },
  btn_table_bottom_left: {
    type: 'button.secondary',
    size: 'medium',
  },

  btn_table_bottom_right: {
    type: 'button.secondary',
    size: 'small',
  },

  btn_table_top_right: {
    type: 'button.primary',
    size: 'medium',
  },

  btn_table_action: {
    type: 'button.icon',
    size: 'large',
  },

  btn_table_config: {
    type: 'button.fab',
    size: 'large',
  },
};
